import { useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import Box from "../../components/Box";
import Pagination from "../../components/Pagination";
import { useODPlistHooks } from "../../utils/infrastructure/OdpUtils";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import ModalCreateOdp from "../../components/infrastrucure/odp/ModalCreateOdp";
import ModalUpdateOdp from "../../components/infrastrucure/odp/ModalUpdateOdp";
import AlertBox from "../../components/AlertBox";
import ModalDeleteOdp from "../../components/infrastrucure/odp/ModalDeleteOdp";

export default function ManageOdpPage() {
  const { hasAccess } = useControlPermission();
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [formFilter, setFormFilter] = useState({ q: "" });
  const [filter, setFilter] = useState({ q: "", page: 1, page_size: 10 });

  const { data: odpData, meta, loading, errorMsg } = useODPlistHooks({ filter });

  const [selectedId, setSelectedId] = useState("");
  const [modal, setModal] = useState("");

  const applyFilter = () => {
    let form_filter = { ...filter, ...formFilter, page: 1 };
    setFilter(form_filter);
  };

  const resetFilter = () => {
    setFormFilter({ q: "" });
    setFilter({ q: "", page: 1, page_size: 10 });
  };

  // create, update, delete
  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  const onSuccess = (message) => {
    setAlert({ show: true, message, type: "success" });
    setFilter({ ...filter });
  };

  return (
    <MainLayout resource_key="infrastructure">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Manajemen ODP</h1>
          </div>
          {hasAccess("create-odp") && (
            <div className="col-auto">
              <button className="btn btn-primary" onClick={() => setModal("create")}>
                <i className="fa fa-plus"></i> Tambah ODP
              </button>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12">
            <Box title={`Daftar ODP`} loading={loading}>
              <div className="row">
                <div className="col-lg-2 col-12">
                  <div className="form-group">
                    <label>Pencarian</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="kode / deskripsi ..."
                      value={formFilter.q}
                      onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              <AlertBox {...alert} setAlert={setAlert} />
              {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
              <div className="auto-horizontal-scroll">
                <table className="table table-hover table-bordered table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Kode</th>
                      <th>OLT</th>
                      <th>Deskripsi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {odpData.length === 0 && (
                      <tr>
                        <td colSpan={4} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )}
                    {odpData.map((odp) => (
                      <tr key={odp.id}>
                        <td style={{ width: "150px" }}>
                          <div className="d-flex" style={{ gap: "4px" }}>
                            {hasAccess("update-odp") && (
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  setSelectedId(odp.id);
                                  setModal("update");
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                            )}
                            {hasAccess("delete-odp") && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setSelectedId(odp.id);
                                  setModal("delete");
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            )}
                          </div>
                        </td>
                        <td>{odp.code}</td>
                        <td>{odp.olt?.name || "-"}</td>
                        <td>{odp.description || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>

      <ModalCreateOdp
        show={modal === "create"}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />

      <ModalUpdateOdp
        show={modal === "update"}
        id={selectedId}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />

      <ModalDeleteOdp
        show={modal === "delete"}
        id={selectedId}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />
    </MainLayout>
  );
}
